var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"awardContainer"},[_c('iconic',{class:[`c${_vm.award._id}${_vm.modelId}`, _vm.isBlocked ? 'isBlocked' : ''],attrs:{"name":_vm.award.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }